<template>
  <div
    v-if="isShow.companyImages"
    class="contents-inner"
    data-test="images"
  >
    <vue-slick-carousel
      class="main-slider image-height-auto"
      v-bind="settings"
    >
      <template v-for="index in [1,2,3]">
        <div
          v-if="companyInfo[`companyImage${index}Caption`]"
          :key="index"
          class="item-slider image-height-auto"
          :data-test="`image-wrap-${index}`"
        >
          <div
            :style="`background: url(${userCommonImageUrlForSp}/bg_stripe_gray.png) repeat top left;`"
            :data-test="`image-background-${index}`"
          >
            <img
              v-if="companyInfo[`companyImage${index}`].id"
              :src="getPhotoUrl(companyInfo[`companyImage${index}`])"
              class="max-w100"
              :alt="companyInfo[`companyImage${index}Caption`]"
              :data-test="`image-${index}`"
            >
            <div class="slider-caption-parent">
              <p
                class="slider-caption"
                :data-test="`caption-${index}`"
              >
                {{ companyInfo[`companyImage${index}Caption`] }}
              </p>
            </div>
          </div>
        </div>
      </template>
    </vue-slick-carousel>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/company/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
// USER側でjQueryのslickを利用している処理をvue-slick-carouselで実装するために必要なファイル読み込み
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  components: {
    VueSlickCarousel
  },
  mixins: [jobPreviewCommon],
  props: {
    companyInfo: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      settings: {
        autoplay: true, // 自動再生
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        dots: true, // ドット状のナビ
        arrows: false, // 矢印
        dotsClass: 'slider-dots' // ドット状のナビのclass名
      }
    }
  }
}
</script>
